import styles from './SentimentModal.module.scss'
import {BaseModal} from '../../../../../../components/BaseModal/BaseModal'
import {useState} from 'react'
import {
  WuIcon,
  WuSegmentedSelector,
  WuSegmentedSelectorItem,
  WuTable,
} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../../../../../Translation/English/dialog'

interface ISentimentModalProps {
  showModal: boolean
  closeModal: () => void
  data: {
    type: string
    percentage: number
    responses?: Array<string>
    keywords?: Array<{
      keyword: string
      occurrences: number
    }>
  } | null
}

export const SentimentModal: React.FC<ISentimentModalProps> = ({
  showModal,
  closeModal,
  data,
}) => {
  const wt = useWt()
  const [selectedValue, setSelectedValue] = useState('responses')

  const getHeader = (): React.ReactElement => {
    return <div className={styles.title}>{data?.type}</div>
  }

  const getIcon = (sentiment: string): React.ReactElement | null => {
    switch (sentiment.toLocaleLowerCase()) {
      case 'positive':
        return (
          <WuIcon
            icon="wm-sentiment-satisfied"
            className={styles.sentimentModalResponsesGreen}
          />
        )
      case 'negative':
        return (
          <WuIcon
            icon="wm-sentiment-dissatisfied"
            className={styles.sentimentModalResponsesRed}
          />
        )
      case 'neutral':
        return (
          <WuIcon
            icon="wm-sentiment-neutral"
            className={styles.sentimentModalResponsesYellow}
          />
        )
      default:
        return null
    }
  }

  const getResponseLabel = (_sentiment: string): React.ReactElement => {
    return (
      <>
        <div className={styles.sentimentModalLabelText}>
          {wt(DIALOG.responses)}
        </div>
        <div className={styles.sentimentModalLabelCount}>
          {data?.responses?.length}
        </div>
      </>
    )
  }

  const radioOptions = [
    {value: 'responses', label: getResponseLabel('negative')},
    {value: 'keywords', label: wt(DIALOG.keywords)},
  ]

  return (
    <BaseModal
      visible={showModal}
      headerTitle={getHeader()}
      onCloseModal={() => closeModal()}
      maxWidth="750px"
    >
      <div className={styles.sentimentModal}>
        <div className={styles.sentimentModalRadioGroup}>
          <WuSegmentedSelector
            value={selectedValue}
            onChange={setSelectedValue}
          >
            {radioOptions.map(option => (
              <WuSegmentedSelectorItem
                key={option.value}
                value={option.value}
                className={styles.sentimentModalLabel}
              >
                {option.label}
              </WuSegmentedSelectorItem>
            ))}
          </WuSegmentedSelector>
        </div>
        {selectedValue === 'responses' && (
          <div className={styles.sentimentModalResponses}>
            {data?.responses?.map((response, index) => (
              <div key={index} className={styles.sentimentModalResponsesItem}>
                <div className={styles.sentimentModalResponsesSentiment}>
                  {getIcon(data?.type || '')}
                </div>
                <div className={styles.sentimentModalResponsesText}>
                  {response}
                </div>
              </div>
            ))}
          </div>
        )}
        {selectedValue === 'keywords' && (
          <div className={styles.keywords}>
            <WuTable
              className="wui-goals-table"
              columns={[
                {
                  accessorKey: 'keyword',
                  header: wt(DIALOG.keywords) as string,
                },
                {
                  accessorKey: 'occurrences',
                  header: wt(DIALOG.occurrences) as string,
                },
              ]}
              data={data?.keywords || []}
            />
          </div>
        )}
      </div>
    </BaseModal>
  )
}
